










import { FitIcon, FitToast } from '@/fit-ui';
import { Component, Prop, Vue } from 'vue-property-decorator';
import { LoadingType } from './business';
import store from './store';

@Component({
  components: {
    FitIcon,
    FitToast,
  },
})
export default class FitLoading extends Vue {
  get showDotLine() {
    return !!((this.loading.type === LoadingType.Security || this.loading.type === LoadingType.WechatPay));
  }
  public loading = store.loading;
  @Prop({ default: 'loading' }) public type!: string;
}
